import { render, staticRenderFns } from "./CredorStats.vue?vue&type=template&id=05f4267a&"
import script from "./CredorStats.vue?vue&type=script&lang=js&"
export * from "./CredorStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports